import PageLoader from '@components/PageLoader'
import { useBreadcrumbs } from '@context/BreadcrumbContext'
import { useIdeas, useTrip } from '@hooks'
import React from 'react'
import { useParams } from 'react-router-dom'
import Board from './Board'
import { ErrorContainer, IdeasPageContainer, LoadingContainer } from './IdeasPage.styles'

const IdeasPage: React.FC = () => {
	const { tripId } = useParams<{ tripId: string }>()
	const { data: trip, isLoading: tripLoading, error: tripError } = useTrip(tripId)
	const { data: ideasData, isLoading: ideasLoading, error: ideasError } = useIdeas(tripId)

	// Set breadcrumbs - must be called before any early returns
	useBreadcrumbs(
		trip
			? [
					{ label: trip.name, path: `/trips/${tripId}` },
					{ label: 'Ideas' },
				]
			: [],
	)

	if (tripLoading || ideasLoading) {
		return (
			<LoadingContainer>
				<PageLoader label="Loading ideas…" />
			</LoadingContainer>
		)
	}

	if (tripError || ideasError) {
		return (
			<ErrorContainer>
				<p>Error loading ideas. Please try again.</p>
			</ErrorContainer>
		)
	}

	if (!trip) {
		return (
			<ErrorContainer>
				<p>Trip not found</p>
			</ErrorContainer>
		)
	}

	const ideas = ideasData?.ideas || []

	return (
		<IdeasPageContainer>
			<Board tripId={tripId!} ideas={ideas} />
		</IdeasPageContainer>
	)
}

export default IdeasPage
